import React, {useState, useEffect} from "react";
import { GetCourseInstructorA, GetInstituteInstructorsA } from "../../../Actions/InstructorA";
import { GetCourseNameA, GetScheduleA } from "../../../Actions/StudentA";
import { useDispatch, useSelector } from "react-redux";
import { BaseUrl } from "../../../Actions/Base";
import ShowMappedLearnerClasses from "./ShowMappedLearnerClasses";

const UpcomingClassesSchedule= ({EnrollmentId}) => {
    const Dispatch = useDispatch();

    const { UserInfo } = useSelector((Store) => Store.LoginSignupReducer);
    const { Schedule, CoursePackage } = useSelector((Store) => Store.StudentReducer);
    const { Instructors, loading } = useSelector(
        (store) => store.InstructorReducer
      );
    const { CourseInstructors } = useSelector(Store => Store.InstructorReducer)
    const [error, setError] = useState('');

    const [showStudentMappedClasses, setShowStudentMappedClasses] = useState(false);

    console.log("EnrollmentId in params is:", EnrollmentId);
    console.log("Schedule in params is:", Schedule);
    console.log("Instructors in params is:", Instructors);
    console.log("CoursePackage", CoursePackage);
    console.log("CourseInstructorsss", CourseInstructors)

    const totalClasses = Schedule?.length || 0;

    const completedClasses = Schedule?.filter(item => item.classStatus === 'Completed').length || 0;
    const missedClasses = Schedule?.filter(item => item.classStatus === 'Missed').length || 0;
    const rescheduledClasses = Schedule?.filter(item => item.classStatus === 'Rescheduled').length || 0;    

    // Assuming these are passed as props or defined above
    const coursePackage = CoursePackage; // your object
    const schedule = Schedule; // your array of class events

    // Extract dates from schedule and convert them to Date objects
    const classDates = schedule?.map(item => new Date(item.startDate));

    // Sort dates to find min (start) and max (end)
    const sortedDates = classDates?.sort((a, b) => a - b);

    const startDate = sortedDates?.[0];
    const endDate = sortedDates?.[sortedDates.length - 1];

    // Format the date as "17 Jun" using toLocaleDateString
    const formatDate = (date) =>
      date?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });

    const formattedDuration =
      startDate && endDate ? `${formatDate(startDate)} - ${formatDate(endDate)}` : 'N/A';

    // Extract other values
    const courseName = coursePackage?.InstituteCourse?.Course?.CourseName || 'N/A';
    const packageName = coursePackage?.PackageName || 'N/A';
    const drivingHours = coursePackage?.DrivingHours || 0;
    const inClassHours = coursePackage?.InClassHours || 0;
    const onlineHours = coursePackage?.OnlineHours || 0;
    const courseImage = `${BaseUrl}/api/Thumbnail/course?url=${coursePackage?.InstituteCourse?.Course?.CourseThumbnail}`;

    useEffect(() => {
        if (EnrollmentId) {
          Dispatch(GetScheduleA(EnrollmentId));
          Dispatch(GetCourseNameA(EnrollmentId));
          Dispatch(GetCourseInstructorA(EnrollmentId))
        }
        // Define dummy filters with default values
        const dummyFilters = {
          sortByTime: "asc", // or "desc" depending on your needs
          sortBy: "name", // or any other field you want to sort by
          searchQuery: "", // Use search prop or an empty string
          suspend: "false", // or any other value required
        };
    
        // Call the action with the dummy filters
        Dispatch(GetInstituteInstructorsA(dummyFilters));
      }, [Dispatch, EnrollmentId]);

      const handleIconClick = () => {
        setShowStudentMappedClasses(!showStudentMappedClasses)
      }

     
    return (
      <div className="w-full flex flex-col gap-[20px]">
        <div className="w-full flex justify-center items-center mt-[20px]">
           <div className="w-[90%] rounded-[14px] py-[15px] px-[25px]"
                style={{border:"1px solid #707070"}}>
                <div className="w-full flex items-center gap-[50px]">
                      <div className="flex flex-col gap-[10px]">
                          <p className="text-[22px] font-semibold">Total Classes</p>
                          <p className="text-[22px]">{totalClasses}</p>
                      </div>

                      <div className="flex flex-col gap-[10px]">
                          <p className="text-[22px] font-semibold">Classes Completed</p>
                          <p className="text-[22px]">{completedClasses}</p>
                      </div>


                      <div className="flex flex-col gap-[10px]">
                          <p className="text-[22px] font-semibold">Missed</p>
                          <p className="text-[22px]">{missedClasses}</p>
                      </div>

                      <div className="flex flex-col gap-[10px]">
                          <p className="text-[22px] font-semibold">Reschedule</p>
                          <p className="text-[22px]">{rescheduledClasses}</p>
                      </div>

                </div>

                <div className="w-full rounded-[9px] py-[15px] px-[25px] flex items-center flex-wrap gap-[50px] mt-[30px]"
                     style={{border:"1px solid #A4A4A4"}}>
                    <div className="flex items-center gap-[10px]">
                        <div className="w-[60px] h-[60px] bg-[#707070]">
                        <img
                                className="w-[60px] h-[60px] "
                                src={courseImage}
                                alt=""
                            />
                        </div>
                        <div className="flex flex-col gap-[10px]">
                            <p className="text-[22px] font-semibold">Course Name</p>
                            <p className="text-[22px]">{courseName}</p>
                        </div>
                    </div>

                    <div className="flex flex-col gap-[10px]">
                            <p className="text-[22px] font-semibold">Course Duration</p>
                            <p className="text-[22px]">{formattedDuration}</p>
                    </div>

                    <div className="flex flex-col gap-[10px]">
                            <p className="text-[22px] font-semibold">Package Name</p>
                            <p className="text-[22px]">{packageName}</p>
                    </div>

                    <div className="flex flex-col gap-[10px]">
                            <p className="text-[22px] font-semibold">In-Vehicle Hrs</p>
                            <p className="text-[22px]">{drivingHours}</p>
                    </div>

                    <div className="flex flex-col gap-[10px]">
                            <p className="text-[22px] font-semibold">In-Class Hrs</p>
                            <p className="text-[22px]">{inClassHours}</p>
                    </div>

                    <div className="flex flex-col gap-[10px]">
                            <p className="text-[22px] font-semibold">Online/Other Hrs</p>
                            <p className="text-[22px]">{onlineHours}</p>
                    </div>

                    <div className="w-[50px] h-[50px] rounded-full bg-[#A1A3EF] flex justify-center items-center"
                          onClick={handleIconClick}>
                        <img className='h-6 relative -top-[2px] md:top-0 md:h-auto' 
                              // src={require('../Assets/Plusicon.svg').default} 
                              src={
                                  showStudentMappedClasses
                                    ? require('../Assets/Minusicon.svg').default
                                    : require('../Assets/Plusicon.svg').default
                                }
                              alt=""
                          />
                    </div>
                </div>

                {showStudentMappedClasses && (
                    <ShowMappedLearnerClasses
                        schedule={Schedule}
                        totalClasses={totalClasses}
                        CourseInstructors={CourseInstructors}
                        setError={setError}
                        EnrollmentId={EnrollmentId}
                    />
                )}
           </div>

           {error && (
                <div className="fixed flex items-center gap-[10px] bottom-5 right-5 z-[9999] px-6 py-2 rounded-lg 
                bg-[linear-gradient(90deg,_#FFFFFF_0%,_#DFE0FF_28%,_#D7D9FF_100%)] bg-no-repeat text-[#F93D5C] text-[16px] shadow-[0_0_8px_#00000029] rounded-[4px] animate-fade-in-out
                max-w-[450px] 2.5xl:max-w-[550px] whitespace-pre-wrap break-words"
                style={{border:"1px solid #DCDCDC"}}>
                    <img className='h-6 relative -top-[2px] md:top-0 md:h-auto' 
                        src={require('../Assets/ErrorIcon.svg').default} 
                        alt=""
                    /> 
                    {error}
                </div>
            )}

        </div>
        
        <div className="w-full flex justify-center items-center mt-[20px]">
            <div className="w-[90%] flex items-center gap-[40px]">
                  <div className="flex items-center gap-[10px]">
                      <div className="w-[24px] h-[24px] bg-[#0AA630]"></div>
                      <p className="text-[16px] text-[#404040]">In-Vehicle Hours</p>
                  </div>

                  <div className="flex items-center gap-[10px]">
                      <div className="w-[24px] h-[24px] bg-[#5298F5]"></div>
                      <p className="text-[16px] text-[#404040]">In-Class hours</p>
                  </div>

                  <div className="flex items-center gap-[10px]">
                      <div className="w-[24px] h-[24px] bg-[#FC0000]"></div>
                      <p className="text-[16px] text-[#404040]">Online/Other Hours</p>
                  </div>
            </div>
        </div>

      </div>
    );
};

export default UpcomingClassesSchedule;


{/* <div className="w-full rounded-[9px] py-[15px] px-[25px] flex items-center justify-between mt-[30px]"
    style={{border:"1px solid #A4A4A4"}}>
  <div className="flex gap-[20px]">
      <div className="flex flex-col items-center gap-[5px]">
        <p className="text-[22px] font-semibold">JUN</p>
        <p className="text-[22px] font-semibold">21</p>
      </div>

      <div className="flex flex-col gap-[5px]">
        <p className="text-[22px] font-semibold">Saturday, 09:00 AM - 10:00 AM</p>
        <div className="w-[97px] h-[37px] rounded-[7px] bg-[#FEF5C5] flex justify-center items-center">
            <p className="text-[20px] font-semibold">Pending</p>
        </div>
      </div>
  </div>

  <div className="flex items-center gap-[20px]">
        <p className="text-[22px] font-semibold">Class 1/23</p>
        <div className="w-[97px] h-[37px] rounded-[7px] bg-[#FC000059] flex justify-center items-center">
            <p className="text-[20px] font-semibold">Online</p>
        </div>
        <button
            className="relative text-lg font-bold px-2 rounded cursor-pointer"
            onClick={(e) => {
                e.stopPropagation(); // Prevent the row click event
                // toggleDropdown(rowId); // Open/close dropdown for this specific row
            }}
        >
            &#x2026; 
        </button>
  </div>
</div> */}
